var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d6e8f9da00"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d6e8f9da00)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.484375 0 L 29.515625 0 L 29.515625 29.03125 L 0.484375 29.03125 Z M 0.484375 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1672c9",
    d: "M 15 0 C 7.015625 0 0.484375 6.53125 0.484375 14.515625 C 0.484375 22.5 7.015625 29.03125 15 29.03125 C 22.984375 29.03125 29.515625 22.5 29.515625 14.515625 C 29.515625 6.53125 22.984375 0 15 0 Z M 20.371094 14.082031 L 16.015625 18.433594 C 15.726562 18.726562 15.433594 18.871094 15 18.871094 C 14.566406 18.871094 14.273438 18.726562 13.984375 18.433594 L 9.628906 14.082031 C 9.046875 13.5 9.046875 12.628906 9.628906 12.046875 C 10.210938 11.46875 11.082031 11.46875 11.660156 12.046875 L 15 15.386719 L 18.339844 12.046875 C 18.917969 11.46875 19.789062 11.46875 20.371094 12.046875 C 20.953125 12.628906 20.953125 13.5 20.371094 14.082031 Z M 20.371094 14.082031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon);
export default __webpack_public_path__ + "static/media/assistant-icon.a23a27258b88004567c73574dec0343c.svg";
export { ForwardRef as ReactComponent };